import { DeadLetterStatus, HealthStatus } from './models';

export type Tone = 'ok' | 'warn' | 'bad' | 'neutral';

// The class that sets --status and --status-bg for an element; neutral resets them to grey inside a coloured one.
export function toneClass(tone: Tone): string {
  return `tone-${tone}`;
}

// What could not be judged (no data, no access) stays neutral: it says nothing about the app.
export function healthTone(status: HealthStatus): Tone {
  switch (status) {
    case 'Healthy':
      return 'ok';
    case 'Degraded':
      return 'warn';
    case 'Unhealthy':
    case 'Error':
      return 'bad';
    default:
      return 'neutral';
  }
}

export function deadLetterTone(status: DeadLetterStatus): Tone {
  switch (status) {
    case 'Clean':
      return 'ok';
    case 'DeadLettered':
      return 'bad';
    default:
      return 'neutral';
  }
}
